/* screens/checkout/CheckoutRow.jsx — унифицированная строка деталей платежа (S11).
   // заменяет: дублирующиеся <div class="row"> в CheckoutMock/Success/Fail (фикс №15).
   Пропсы: label, value (string|node), tone? (success|danger|muted), mono? (числа/ID).
   ХЕНДОФФ: → frontend/src/components/checkout/CheckoutRow.jsx. */

  function CheckoutRow({ label, value, tone, mono }) {
    const valCls = 'checkout-row__value'
      + (tone ? ' checkout-row__value--' + tone : '')
      + (mono ? ' num' : '');
    return (
      <div className="checkout-row">
        <span className="checkout-row__label">{label}</span>
        <span className={valCls}>{value}</span>
      </div>
    );
  }

export { CheckoutRow };
